import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Amplify } from "aws-amplify";
Amplify.configure(window.amplify);
ReactDOM.render(/* @__PURE__ */ React.createElement(App, null), document.getElementById("root"));
serviceWorker.unregister();
